<!--高速公路视频监控AI智能监测平台-->
<template>
	<div class="system-container">
		<div class="section">
			<div class="section-content">
				<div class="title">平台概述</div>
				<p class="text">
					随着高速公路里程和车流量的增加，传统视频监控系统已无法满足实时监测和预警的需求。为提升高速公路安全管理水平，需将AI技术融入视频监控系统，赋予传统摄像头AI能力，实现对交通事故事件的主动监测与预警。
				</p>
				<img class="image" src="@/assets/image/prescription/fun_model5.png" alt />
			</div>
		</div>
		<div class="section" style="background-color: #EAF3FF">
			<div class="section-content">
				<div class="title">核心硬件</div>
				<div class="img-ct">
					<div class="img-li">
						<img class="img" src="@/assets/image/prescription/fun_model6.png" alt />
						<div class="info">网络摄像机</div>
					</div>
					<div class="img-li">
						<img class="img" src="@/assets/image/prescription/fun_model7.png" alt />
						<div class="info">智能边缘AI运算盒</div>
					</div>
				</div>

			</div>
		</div>
		<div class="section">
			<div class="section-content">
				<div class="title">功能模块</div>
				<div class="panel-content">
					<div class="panel" v-for="(item,index) in panelList" :key="index">
						<img class="image" :src="item.icon" style="width: 60px;height: 60px;" alt />
						<div>
							<div class="label">{{ item.label }}</div>
							<p class="info">{{ item.text }}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	//components
	import Carousel from '@/components/Carousel';

	export default {
		components: {
			Carousel
		},
		name: 'freewayDecision',
		data() {
			return {
				panelList: [{
						icon: require('@/assets/image/prescription/icon_20.png'),
						label: '目标检测与跟踪',
						text: '识别车辆、行人等目标并跟踪其运动轨迹。'
					},
					{
						icon: require('@/assets/image/prescription/icon_24.png'),
						label: '事件检测',
						text: '识别交通事故、拥堵、违章停车、逆行等事件。'
					},
					{
						icon: require('@/assets/image/prescription/icon_22.png'),
						label: '行为分析',
						text: '分析车辆速度、密度、流量等数据，识别异常行为。'
					}, {
						icon: require('@/assets/image/prescription/icon_23.png'),
						label: '预警管理模块',
						text: '根据事件类型和严重程度，生成预警信息并推送至相关人员。'
					},
					{
						icon: require('@/assets/image/prescription/icon_29.png'),
						label: '数据管理模块',
						text: '存储和管理视频数据、事件数据和预警信息。'
					},
					{
						icon: require('@/assets/image/prescription/icon_26.png'),
						label: '系统管理模块',
						text: '负责用户权限、设备管理和系统配置。'
					}
				]
			};
		},
		mounted() {},
		methods: {
			//切换图片
			toggleImage(type) {
				this.$refs.carousel[type]();
			}
		}
	}
</script>


<style scoped lang="scss">
	.system-container {
		height: 100%;
		width: 100%;

		.section {
			height: 100%;
			width: 100%;

			.section-content {
				margin: 0 auto;
				width: 1200px;
				padding: 50px 0;
				text-align: center;

				.title {
					text-align: center;
					font-size: 32px;
				}

				.text {
					margin-top: 40px;
					text-indent: 2em;
					line-height: 32px;
					font-size: 20px;
					text-align: justify;
				}

				.image {
					margin-top: 60px;
					width: 1020px;
				}

				.img-ct {
					width: 100%;
					display: flex;
					flex-direction: row;

					.img-li {
						width: 50%;
						display: flex;
						flex-direction: column;
						padding: 0 10%;

						.img {
							width: 100%;
							margin-bottom: 16px;
						}
					}
				}
			}
		}

		.panel-content {
			margin-top: 50px;
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;

			.panel {
				box-sizing: border-box;
				width: calc(100% / 3 - 16px);
				padding: 30px;
				box-shadow: 0 3px 18px 1px rgba(26, 102, 187, 0.14);
				margin-bottom: 24px;

				.label {
					padding: 30px 0;
					font-size: 24px;
					font-weight: bold;
				}

				.info {
					line-height: 32px;
					font-size: 20px;
				}
			}
		}

		.mobile-core {
			display: none;
		}

		.core {
			.core-list {
				margin-top: 24px;
				font-size: 20px;
				display: grid;
				grid-template-columns: repeat(5, 1fr);
				grid-template-rows: repeat(2, 1fr);
				grid-gap: 24px;

				.first {
					grid-row-start: 1;
					grid-row-end: 3;
					display: flex;
					flex-direction: column;
					justify-content: center;
					align-items: center;
				}

				.core-item {
					background-color: #ffffff;
					border-radius: 4px;
					padding: 20px;

					.mobile_image {
						width: 60px;
						height: 60px;
					}

					.mobile_label {
						line-height: 30px;
					}
				}
			}
		}
	}

	@import "./style.scss";
</style>